import React, { useEffect, useState } from "react"
import { Box, FormControl, FormLabel, TextField, Typography, Button } from "@mui/material"
import { useDispatch, useSelector } from "react-redux"
import { fetchTemplatesById } from "../../redux/Slice/showcase/templateSlice"
import { useNavigate, useParams } from "react-router-dom"

const TemplateDetails = () => {
  const navigate = useNavigate()
  const { id } = useParams()
  const dispatch = useDispatch()

  const { selectedTemplate } = useSelector((state) => state.template)
  const [templateHtml, setTemplateHtml] = useState("")
  const [bgColor, setBgColor] = useState("")
  const [productJson, setProductJson] = useState("")

  useEffect(() => {
    if (id) {
      dispatch(fetchTemplatesById(id))
    }
  }, [dispatch, id])

  useEffect(() => {
    if (selectedTemplate?.codeContent) {
      const iframe = document.getElementById("detailsFrame")?.contentWindow?.document
      if (iframe) {
        iframe.open()
        iframe.write(selectedTemplate?.codeContent)
        iframe.close()
        const iframeHtmlString = iframe.documentElement.outerHTML
        setTemplateHtml(iframeHtmlString)
      }
    }
  }, [selectedTemplate])

  const updateColor = () => {
    const iframe = document.getElementById("detailsFrame")
    // if (iframe) {
    //   const iframeDoc = iframe.contentDocument || iframe.contentWindow.document
    //   if (iframeDoc && iframeDoc.body) {
    //     iframeDoc.body.style.backgroundColor = bgColor 
    //     console.log("Background color updated to:", bgColor)
    //   } else {
    //     console.error("Unable to access iframe body.")
    //   }
    // } else {
    //   console.error("Iframe with ID 'detailsFrame' not found.")
    // }

    if (iframe) {
      const header = iframe.querySelector(".header")
      if (header) {
        header.style.backgroundColor = bgColor
        console.log("Header color updated to:", bgColor)
      } else {
        console.error("Iframe with ID 'detailsFrame' not found.")
      }
    }
  }

  const addProduct = () => {
    try {
      const product = JSON.parse(productJson)
      if (product.name && product.image && product.price) {
        const iframe = document.getElementById("detailsFrame")?.contentWindow?.document
        const track = iframe?.getElementById("carousel-track")
        if (track) {
          const productElement = document.createElement("div")
          productElement.className = "carousel-item"
          productElement.innerHTML = `
            <img src="${product.image}" alt="${product.name}">
            <h3>${product.name}</h3>
            <p>${product.price}</p>
          `
          track.appendChild(productElement)
        }
      } else {
        alert("Invalid product data. Ensure 'name', 'image', and 'price' are provided.")
      }
    } catch (error) {
      alert("Invalid JSON format.")
    }
  }

  return (
    <Box sx={{ padding: 2 }}>
      <Typography variant="h4">Template Details</Typography>

      <Box sx={{ display: "flex", flexDirection: "row", gap: 2, marginTop: 2 }}>
        <iframe
          id="detailsFrame"
          title="HTML Preview"
          style={{
            width: "100%",
            height: "500px",
            border: "1px solid #333",
            overflow: "auto",
            borderRadius: "10px",
          }}
        />

        <Box sx={{ width: "50%", display: "flex", flexDirection: "column", gap: 2 }}>
          <FormControl fullWidth>
            <FormLabel>Pick a Background Color</FormLabel>
            <input
              type="color"
              value={bgColor}
              onChange={(e) => setBgColor(e.target.value)}
              style={{
                width: "100%",
                height: "40px",
                border: "none",
                cursor: "pointer",
              }}
            />
            <Button onClick={updateColor} variant="contained" sx={{ marginTop: 2 }}>
              Apply Color
            </Button>
          </FormControl>

          <FormControl fullWidth>
            <FormLabel>Add Product (JSON Format)</FormLabel>
            <textarea label="Product JSON" value={productJson} onChange={(e) => setProductJson(e.target.value)} variant="outlined" multiline fullWidth height={500} />
            <Button onClick={addProduct} variant="contained" sx={{ marginTop: 2 }}>
              Add Product
            </Button>
          </FormControl>
        </Box>
      </Box>

      {/* <Box sx={{ marginTop: 4 }}>
        <Typography variant="h6">Iframe HTML as String:</Typography>
        <textarea
          value={templateHtml}
          multiline
          width="100%"
          sx={{
            marginTop: 2,
          }}
        />
      </Box> */}
    </Box>
  )
}

export default TemplateDetails
